/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as NpmPackagesRouteImport } from './routes/npm-packages';
import { Route as FormsRouteImport } from './routes/forms';
import { Route as ContentfulRouteImport } from './routes/contentful';
import { Route as ColorPaletteRouteImport } from './routes/color-palette';
import { Route as ApiDemoRouteImport } from './routes/api-demo';
import { Route as IndexRouteImport } from './routes/index';

const NpmPackagesRoute = NpmPackagesRouteImport.update({
  id: '/npm-packages',
  path: '/npm-packages',
  getParentRoute: () => rootRouteImport,
} as any);
const FormsRoute = FormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => rootRouteImport,
} as any);
const ContentfulRoute = ContentfulRouteImport.update({
  id: '/contentful',
  path: '/contentful',
  getParentRoute: () => rootRouteImport,
} as any);
const ColorPaletteRoute = ColorPaletteRouteImport.update({
  id: '/color-palette',
  path: '/color-palette',
  getParentRoute: () => rootRouteImport,
} as any);
const ApiDemoRoute = ApiDemoRouteImport.update({
  id: '/api-demo',
  path: '/api-demo',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/api-demo': typeof ApiDemoRoute;
  '/color-palette': typeof ColorPaletteRoute;
  '/contentful': typeof ContentfulRoute;
  '/forms': typeof FormsRoute;
  '/npm-packages': typeof NpmPackagesRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/api-demo': typeof ApiDemoRoute;
  '/color-palette': typeof ColorPaletteRoute;
  '/contentful': typeof ContentfulRoute;
  '/forms': typeof FormsRoute;
  '/npm-packages': typeof NpmPackagesRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/api-demo': typeof ApiDemoRoute;
  '/color-palette': typeof ColorPaletteRoute;
  '/contentful': typeof ContentfulRoute;
  '/forms': typeof FormsRoute;
  '/npm-packages': typeof NpmPackagesRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/api-demo'
    | '/color-palette'
    | '/contentful'
    | '/forms'
    | '/npm-packages';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/api-demo'
    | '/color-palette'
    | '/contentful'
    | '/forms'
    | '/npm-packages';
  id:
    | '__root__'
    | '/'
    | '/api-demo'
    | '/color-palette'
    | '/contentful'
    | '/forms'
    | '/npm-packages';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ApiDemoRoute: typeof ApiDemoRoute;
  ColorPaletteRoute: typeof ColorPaletteRoute;
  ContentfulRoute: typeof ContentfulRoute;
  FormsRoute: typeof FormsRoute;
  NpmPackagesRoute: typeof NpmPackagesRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/npm-packages': {
      id: '/npm-packages';
      path: '/npm-packages';
      fullPath: '/npm-packages';
      preLoaderRoute: typeof NpmPackagesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forms': {
      id: '/forms';
      path: '/forms';
      fullPath: '/forms';
      preLoaderRoute: typeof FormsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/contentful': {
      id: '/contentful';
      path: '/contentful';
      fullPath: '/contentful';
      preLoaderRoute: typeof ContentfulRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/color-palette': {
      id: '/color-palette';
      path: '/color-palette';
      fullPath: '/color-palette';
      preLoaderRoute: typeof ColorPaletteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/api-demo': {
      id: '/api-demo';
      path: '/api-demo';
      fullPath: '/api-demo';
      preLoaderRoute: typeof ApiDemoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApiDemoRoute: ApiDemoRoute,
  ColorPaletteRoute: ColorPaletteRoute,
  ContentfulRoute: ContentfulRoute,
  FormsRoute: FormsRoute,
  NpmPackagesRoute: NpmPackagesRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
